import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AdventureSportsModal from '../AdventureSportsModal';
import ElectronicsTheftModal from '../ElectronicsTheftModal';
import { StyledLearnMoreLink } from './styled';

const LearnMore = ({ addonId }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleLinkClick = (e) => {
    e.stopPropagation();
    setIsModalOpen(true);
  };

  if (addonId === 10) {
    return (
      <>
        <StyledLearnMoreLink onClick={handleLinkClick}>Learn more</StyledLearnMoreLink>
        <AdventureSportsModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />
      </>
    );
  }

  if (addonId === 9) {
    return (
      <>
        <StyledLearnMoreLink onClick={handleLinkClick}>Learn more</StyledLearnMoreLink>
        <ElectronicsTheftModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />
      </>
    );
  }

  return null;
};

LearnMore.propTypes = {
  addonId: PropTypes.number.isRequired
};

export default LearnMore;
